import { FC, ReactNode } from 'react'
import { Box, makeStyles, Typography } from '@perk-ui/core'

const useStyles = makeStyles((theme) => ({
  formHeader: {
    marginBottom: theme.spacing(2),
  },
  navigationHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    minHeight: '40px',
  },
  formTitle: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#1B3A52',
    marginBottom: theme.spacing(1),
    lineHeight: 1.2,
  },
  formDescription: {
    fontSize: '14px',
    color: '#6B7280',
    lineHeight: 1.5,
    marginBottom: 0,
  },
  noteSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#F8F9FA',
    borderRadius: '8px',
    borderLeft: '4px solid #1B3A52',
  },
  noteLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#1B3A52',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: theme.spacing(0.5),
  },
  noteText: {
    fontSize: '14px',
    color: '#374151',
    lineHeight: 1.5,
    margin: 0,
  },
}))

interface FormHeaderProps {
  title: string
  description?: string
  note?: ReactNode
  className?: string
  leftButton?: ReactNode
  rightButton?: ReactNode
}

const FormHeader: FC<FormHeaderProps> = ({
  title,
  description,
  note,
  className,
}) => {
  const classes = useStyles()

  return (
    <Box className={`${classes.formHeader} ${className || ''}`}>
      <Typography className={classes.formTitle}>{title}</Typography>

      {description && (
        <Typography className={classes.formDescription}>
          {description}
        </Typography>
      )}

      {note && (
        <Box className={classes.noteSection}>
          <Typography className={classes.noteLabel}>Note</Typography>
          <Typography className={classes.noteText}>{note}</Typography>
        </Box>
      )}
    </Box>
  )
}

export default FormHeader
